import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

function HonoraryPatronage() {
    return (
        <Row className="g-4" style={{ justifyContent: 'center', alignItems: 'stretch' }}>
            <Col xs={12} sm={12} md={4} lg={4} xl={4} style={{ display: 'flex' }}>
                <Card className="aboutCard" style={{ width: '100%' }}>
                    <Card.Body className="aboutCardBody" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '200px' }}>
                        <img
                            src={`${process.env.PUBLIC_URL}/images/patronat_MinisterZdrowia.jpg`}
                            alt="Patronat Honorowy - Minister Zdrowia"
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'contain',
                                objectPosition: 'center',
                            }}
                        />
                    </Card.Body>
                </Card>
            </Col>
            <Col xs={12} sm={12} md={4} lg={4} xl={4} style={{ display: 'flex' }}>
                <Card className="aboutCard" style={{ width: '100%' }}>
                    <Card.Body className="aboutCardBody" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '200px' }}>
                        <img
                            src={`${process.env.PUBLIC_URL}/images/patronat_Wrocław.jpg`}
                            alt="Patronat Honorowy - Prezydent Wrocławia"
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'contain',
                                objectPosition: 'center',
                            }}
                        />
                    </Card.Body>
                </Card>
            </Col>
            <Col xs={12} sm={12} md={4} lg={4} xl={4} style={{ display: 'flex' }}>
                <Card className="aboutCard" style={{ width: '100%' }}>
                    <Card.Body className="aboutCardBody" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '200px' }}>
                        <img
                            src={`${process.env.PUBLIC_URL}/images/patronat_nfz.png`}
                            alt="Patronat Honorowy - NFZ"
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'contain',
                                objectPosition: 'center',
                            }}
                        />
                    </Card.Body>
                </Card>
            </Col>
            <Col xs={12} sm={12} md={4} lg={4} xl={4} style={{ display: 'flex' }}>
                <Card className="aboutCard" style={{ width: '100%' }}>
                    <Card.Body className="aboutCardBody" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '200px' }}>
                        <img
                            src={`${process.env.PUBLIC_URL}/images/patronat_USK.jpg`}
                            alt="Patronat Honorowy - Uniwersytecki Szpital Kliniczny we Wrocławiu"
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'contain',
                                objectPosition: 'center',
                            }}
                        />
                    </Card.Body>
                </Card>
            </Col>
            <Col xs={12} sm={12} md={4} lg={4} xl={4} style={{ display: 'flex' }}>
                <Card className="aboutCard" style={{ width: '100%' }}>
                    <Card.Body className="aboutCardBody" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '200px' }}>
                        <img
                            src={`${process.env.PUBLIC_URL}/images/patronat_SRCD.png`}
                            alt="Patronat Honorowy - Stowarzyszenie dla Rozwoju Chirurgii Dziecięcej"
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'contain',
                                objectPosition: 'center',
                            }}
                        />
                    </Card.Body>
                </Card>
            </Col>
            <Col xs={12} sm={12} md={4} lg={4} xl={4} style={{ display: 'flex' }}>
                <Card className="aboutCard" style={{ width: '100%' }}>
                    <Card.Body className="aboutCardBody" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '200px' }}>
                        <img
                            src={`${process.env.PUBLIC_URL}/images/patronat_umw.png`}
                            alt="Patronat Honorowy - Uniwersytet Medyczny we Wrocławiu"
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'contain',
                                objectPosition: 'center',
                            }}
                        />
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    )
}

export default HonoraryPatronage;